/** 答案卡示意图：正文里单独一行的 ![图注](kbimg:ID)，与后端 kb.imageRef 一致。 */
const IMAGE_LINE = /^!\[([^\]\n]{0,80})\]\(kbimg:([A-Za-z0-9_-]{1,64})\)$/u;

export type KnowledgeSegment =
  | { kind: 'image'; caption: string; id: string }
  | { kind: 'text'; text: string };

/** 把正文按示意图行拆开：图片单独成段，其余连续的行合成一段文字；没有示意图时返回整段文字。 */
export function splitKnowledgeImages(source: string): KnowledgeSegment[] {
  if (!source.includes('kbimg:')) return [{ kind: 'text', text: source }];
  const segments: KnowledgeSegment[] = [];
  let lines: string[] = [];
  const flush = (): void => {
    const text = lines.join('\n').replace(/^\n+|\n+$/gu, '');
    if (text) segments.push({ kind: 'text', text });
    lines = [];
  };
  for (const line of source.split('\n')) {
    const match = IMAGE_LINE.exec(line.trim());
    if (!match) {
      lines.push(line);
      continue;
    }
    flush();
    segments.push({ kind: 'image', caption: match[1]!.trim(), id: match[2]! });
  }
  flush();
  return segments;
}

/** 插入到正文的示意图引用；图注去掉会破坏格式的方括号和换行。 */
export function knowledgeImageMarkdown(id: string, caption = ''): string {
  return `![${caption.replace(/[[\]\n]/gu, '').slice(0, 80)}](kbimg:${id})`;
}
